<template>
  <!-- 创建数据集/创建模型 -->
  <div class="training-step-create">
    <div class="intxt intxt-bottom">
      <label class="label" for="">
        <i class="required">*</i>{{navType == 1 ? '数据集名称' : '模型名称'}}：
      </label>
      <el-input
        class="input"
        :placeholder="navType == 1 ? '请输入数据集名称' : '请输入模型名称'"
        v-model.trim="datasetData.name"
        maxlength="20"
        show-word-limit
        :disabled="releaseStatus"
      />
    </div>
    <div class="intxt">
      <label class="label" for="">
        <i class="required">*</i>{{navType == 1 ? '数据集描述' : '模型描述'}}：
      </label>
      <el-input
        type="textarea"
        :rows="6"
        maxlength="200"
        show-word-limit
        :placeholder="navType == 1 ? '请输入数据集描述' : '请输入模型描述'"
        v-model.trim="datasetData.content"
        :disabled="releaseStatus"
      />
    </div>
    <div class="btns">
      <el-button
        type="primary"
        :class="['btn-primary', {'events-disable': teacherOrStudentState ? (withdrawReleaseStatus || releaseStatus) : releaseStatus}]"
        @click="createDataset"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainingStepCreate",
  components: {},
  props: {
    navType: {
      type: String,
      default: ''
    },
    Dataset: {
      type: Object,
      default: {}
    },
    releaseStatus: {
      type: Boolean,
      default: false
    },
    withdrawReleaseStatus: {
      type: Boolean,
      default: false
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      datasetData: {
        name: '',
        content: ''
      },
    }
  },
  watch: {
    navType: {
      handler() {
        this.datasetFun(this.navType)
      },
      deep: true,
      immediate: true,
    },
    Dataset: {
      handler() {
        this.datasetFun(this.navType)
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    datasetFun(val) {
      this.datasetData = {
        name: '',
        content: ''
      }
      // 创建数据集
      if (val == 1) {
        this.datasetData = {
          name: this.Dataset.datasetName || '',
          content: this.Dataset.datasetContent || ''
        }
      }
      // 创建模型
      if (val == 3) {
        this.datasetData = {
          name: this.Dataset.modelName || '',
          content: this.Dataset.modelContent || ''
        }
      }
      // this.$forceUpdate()
    },
    createDataset() {
      if (!this.datasetData.name || !this.datasetData.content) {
        return this.$message.error("请将数据相关信息填写完整");
      }
      this.$emit('createDataset', this.datasetData)
    }
  },
}
</script>

<style lang="scss" scoped>
.training-step-create {
  height: 100%;
  padding-top: 24px;
  // position: relative;
}
.intxt {
  font-size: 14px;
  display: flex;
  margin-bottom: 10px;
  .label {
    line-height: 36px;
    &.checkbox-label {
      width: 8em;
    }
  }
  .el-input,
  .el-textarea {
    flex: 1;
    border-radius: 4px;
  }
  .input {
    vertical-align: -2em;
    &.el-input {
      height: 36px;
      &::v-deep .el-input__inner {
        height: 36px;
      }
    }
  }
  .checkbox {
    margin-top: 20px;
  }
  &::v-deep .el-icon-arrow-up:before {
    content: "\e78f";
  }
  &::v-deep {
    .el-input__count {
      line-height: 1.5;
    }
    .el-input__inner,
    .el-textarea__inner {
      position: relative;
      // border: 1px solid #D8E5FD;
    }
    .el-textarea__inner {
      font-family: sans-serif;
      resize: none;
    }
    .el-input .el-input__count {
        position: absolute;
        top: 72%;
        right: 0.6em;
    }
    .el-input__count {
        position: absolute;
        right: 17px;
        bottom: -18px;
        padding: 0 5px;
    }
  }
}
.intxt-bottom {
  margin-bottom: 20px;
}

.btns {
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  text-align: center;
  button {
    margin-right: 35px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.btn-primary,
.btn-cancel {
  height: $height_btn;
  padding: 0 25px;
  line-height: $height_btn;
}
.btn-primary {
  border-color: $bgc_btn_primary;
  background-color: $bgc_btn_primary;
  &:hover {
    background-color: $bgc_btn_primary_hover;
    border-color: $bgc_btn_primary_hover;
  }
}
.btn-cancel {
  border-color: $bgc_btn_cancel;
  background-color: $bgc_btn_cancel;
  color: $color_btn_cancel;
  &:hover {
    background-color: $bgc_btn_cancel_hover;
    border-color: $bgc_btn_cancel_hover;
  }
}

</style>